export type ClueCategory = {
  id: string;
  name: string;
  slug: string;
  icon: string;
  summary: string;
  count: number;
};

export type Clue = {
  id: string;
  slug: string;
  title: string;
  excerpt: string;
  categoryId: string;
  categoryName: string;
  author: string;
  date: string;
  readTime: string;
  views: number;
  likes: number;
  comments: number;
  tags: string[];
  image: string;
  imageAlt: string;
  hot: boolean;
  picks: boolean;
  content: string[];
  quote?: string;
};

export type Faq = {
  q: string;
  a: string;
};

export const categories: ClueCategory[] = [
  {
    id: "ent",
    name: "娱乐八卦",
    slug: "entertainment",
    icon: "ri-movie-2-line",
    summary: "剧组路透、活动花絮与理性追星讨论，核实后再发布。",
    count: 186,
  },
  {
    id: "society",
    name: "社会民生",
    slug: "society",
    icon: "ri-building-2-line",
    summary: "社区变化、公共设施与日常生活中的真实见闻投稿。",
    count: 241,
  },
  {
    id: "workplace",
    name: "职场内幕",
    slug: "workplace",
    icon: "ri-briefcase-4-line",
    summary: "求职经历、团队文化与行业内幕的匿名分享。",
    count: 158,
  },
  {
    id: "campus",
    name: "校园热点",
    slug: "campus",
    icon: "ri-graduation-cap-line",
    summary: "校园活动、学生社团与青春故事的投稿合集。",
    count: 132,
  },
  {
    id: "consumer",
    name: "消费维权",
    slug: "consumer",
    icon: "ri-shield-star-line",
    summary: "购物踩坑、售后沟通与维权过程的经验整理。",
    count: 203,
  },
  {
    id: "tech",
    name: "科技数码",
    slug: "tech",
    icon: "ri-smartphone-line",
    summary: "新品体验、智能设备实测与数码避坑指南。",
    count: 117,
  },
  {
    id: "life",
    name: "情感生活",
    slug: "life",
    icon: "ri-heart-3-line",
    summary: "真实情感经历与生活观察，温柔而克制地讲述。",
    count: 96,
  },
  {
    id: "city",
    name: "城市见闻",
    slug: "city",
    icon: "ri-map-pin-2-line",
    summary: "街巷故事、小店烟火与城市角落里的人情味。",
    count: 174,
  },
];

export const clues: Clue[] = [
  {
    id: "c1",
    slug: "mall-gift-complaints",
    title: "商场促销赠品频出问题，多位消费者晒出沟通记录",
    excerpt:
      "一场“满额赠好礼”的活动，让不少网友收到了与宣传不符的赠品。有人整理了完整的沟通时间线，也给出了可参考的处理思路。",
    categoryId: "consumer",
    categoryName: "消费维权",
    author: "投稿网友 · 南栀",
    date: "2026-09-08",
    readTime: "6 分钟",
    views: 18420,
    likes: 1264,
    comments: 213,
    tags: ["促销赠品", "售后沟通", "维权经验"],
    image:
      "https://readdy.ai/api/search-image?query=Flat%20vector%20illustration%20of%20shopping%20bags%20and%20receipt%20papers%20on%20a%20warm%20cream%20background%20with%20terracotta%20and%20amber%20shapes%2C%20minimal%20editorial%20style%2C%20soft%20grain%20texture%2C%20no%20text%2C%20balanced%20composition&width=800&height=520&seq=clue-cover-consumer-01&orientation=landscape",
    imageAlt: "消费维权投稿：商场促销赠品与购物小票的插画示意",
    hot: true,
    picks: true,
    quote: "把每一步沟通都留下来，事情反而更容易讲清楚。",
    content: [
      "从八月下旬开始，陆续有网友在后台留言，说自己在某商场“满额赠好礼”活动中拿到的赠品，与宣传海报上展示的样品存在明显差别。有人收到的是明显有使用痕迹的物品，也有人拿到的型号与海报标注并不一致。",
      "投稿人南栀把整件事整理成了一条清晰的时间线：活动当天如何登记、赠品如何领取、发现问题后第一次联系客服的时间、对方给出的回复内容，以及后续几次沟通的变化。她说，把这些信息按顺序排好之后，双方的对话反而顺畅了很多。",
      "在整理投稿的过程中，我们注意到几个反复出现的细节：一是赠品通常在活动现场即时发放，事后追溯难度较大；二是宣传物料上往往只有一句“赠品以实物为准”；三是不同门店对同一活动的执行标准并不完全一致。",
      "南栀的经验是，遇到类似情况先别急着情绪化表达，而是把海报照片、领取凭证、赠品实拍和沟通记录按时间顺序整理好，再一次性说明诉求。“诉求越具体，对方越容易给出明确的答复。”她这样总结。",
      "需要说明的是，本文内容来自网友投稿，仅代表投稿人个人经历与观点。涉及具体品牌与门店的部分，我们已隐去可识别的详细信息，也建议读者在遇到同类问题时，优先通过官方渠道沟通解决。",
    ],
  },
  {
    id: "c2",
    slug: "all-night-bookstore-corners",
    title: "深夜书店成新宠？读者分享城市里的通宵阅读角落",
    excerpt:
      "当写字楼熄灭灯光，总还有几处地方亮着。几位网友投稿，讲述了他们各自心中最适合深夜阅读的那片角落。",
    categoryId: "city",
    categoryName: "城市见闻",
    author: "投稿网友 · 老周",
    date: "2026-09-06",
    readTime: "5 分钟",
    views: 14360,
    likes: 982,
    comments: 168,
    tags: ["深夜书店", "城市角落", "阅读生活"],
    image:
      "https://readdy.ai/api/search-image?query=Flat%20vector%20illustration%20of%20a%20cozy%20late%20night%20reading%20corner%20with%20a%20lamp%2C%20stacked%20books%20and%20window%2C%20warm%20amber%20light%20on%20cream%20background%2C%20minimal%20editorial%20style%2C%20soft%20grain%2C%20no%20text&width=800&height=520&seq=clue-cover-city-02&orientation=landscape",
    imageAlt: "城市见闻投稿：深夜书店阅读角落的插画示意",
    hot: true,
    picks: false,
    quote: "深夜的阅读，其实是给自己留一段没人打扰的时间。",
    content: [
      "投稿人老周说，他习惯在下班后绕一段路，去一家凌晨还亮着灯的小书店坐一会儿。那里没有背景音乐，只有翻书声和老式钟表的走动声，店员会安静地给每个人续一杯热水。",
      "在征集“深夜阅读角落”的过程中，我们收到了不少类似的分享。有人在便利店的靠窗座位读完了大半本小说，有人在社区自习室里认识了后来的朋友，也有人只是喜欢地铁末班车上那段摇晃的阅读时间。",
      "这些地方并不都是传统意义上的书店。它们的共同点，是提供了一种“可以安静待着”的氛围，让人暂时从白天被切割得零碎的时间里抽离出来。",
      "老周在投稿结尾写了一句让人印象很深的话：我们记住一个城市，往往不是因为它的地标，而是因为某个深夜它愿意为你留一盏灯。",
      "本文根据多位网友投稿整理，涉及的个人经历均获授权发布。如果你也有属于自己的深夜阅读角落，欢迎通过投稿入口与我们分享。",
    ],
  },
  {
    id: "c3",
    slug: "overtime-culture-details",
    title: "前员工讲述团队加班文化：那些没说出口的细节",
    excerpt:
      "一位不愿具名的投稿人回顾了自己两年的工作经历，从入职期待到逐渐疲惫，他更想聊的是那些“大家都懂但很少说”的细节。",
    categoryId: "workplace",
    categoryName: "职场内幕",
    author: "投稿网友 · 匿名",
    date: "2026-09-04",
    readTime: "7 分钟",
    views: 21780,
    likes: 1583,
    comments: 342,
    tags: ["职场文化", "加班", "实名建议"],
    image:
      "https://readdy.ai/api/search-image?query=Flat%20vector%20illustration%20of%20a%20quiet%20office%20desk%20at%20night%20with%20laptop%20and%20coffee%2C%20terracotta%20and%20amber%20accents%20on%20cream%20background%2C%20minimal%20editorial%20style%2C%20soft%20grain%20texture%2C%20no%20text&width=800&height=520&seq=clue-cover-work-03&orientation=landscape",
    imageAlt: "职场内幕投稿：夜间办公桌与电脑的插画示意",
    hot: true,
    picks: true,
    quote: "真正消耗人的，往往不是加班本身，而是不确定的等待。",
    content: [
      "这位投稿人用很平静的语气，回顾了自己在某团队工作的两年。入职时他被“弹性工作”吸引，后来才慢慢理解，弹性往往意味着“随时在线”。",
      "他并没有去指责某个人，而是梳理了几类反复出现的场景：临近下班临时拉会、周末群消息不断、请假时需要提前很久报备，以及“自愿留下”的氛围如何一点点形成。",
      "在他看来，比起具体的加班时长，更让人疲惫的是那种不确定感——你永远不知道今天能不能按时下班，也不知道一句“再看一下”意味着半小时还是三个小时。",
      "投稿中也有一些建设性的部分。他建议团队把“响应边界”写清楚，比如紧急事项如何界定、非工作时段消息的预期是什么、月度高峰如何提前排期。“把模糊的地方说明白，比号召大家更努力更有用。”",
      "本文为网友匿名投稿，内容代表投稿人个人感受，不针对任何具体企业或团队。我们鼓励理性、就事论事的职场讨论，也欢迎从制度改进角度出发的经验分享。",
    ],
  },
  {
    id: "c4",
    slug: "campus-secondhand-warm-stories",
    title: "校园二手交易群里的暖心故事，被网友整理成合集",
    excerpt:
      "从一本写满笔记的专业书，到毕业前送出的一盏台灯，校园二手群里藏着很多细碎的善意。有网友把它们整理成了一份合集。",
    categoryId: "campus",
    categoryName: "校园热点",
    author: "投稿网友 · 阿柚",
    date: "2026-09-02",
    readTime: "4 分钟",
    views: 11940,
    likes: 876,
    comments: 121,
    tags: ["校园生活", "二手交易", "青春故事"],
    image:
      "https://readdy.ai/api/search-image?query=Flat%20vector%20illustration%20of%20second%20hand%20campus%20items%20like%20books%2C%20a%20desk%20lamp%20and%20a%20bicycle%20basket%2C%20warm%20amber%20and%20sage%20palette%20on%20cream%20background%2C%20minimal%20editorial%20style%2C%20no%20text&width=800&height=520&seq=clue-cover-campus-04&orientation=landscape",
    imageAlt: "校园热点投稿：校园二手闲置物品的插画示意",
    hot: false,
    picks: true,
    quote: "很多交易最后变成了“交个朋友”，钱反而不重要了。",
    content: [
      "阿柚是某高校读书会的小编，她把校园二手群里近一年的聊天记录翻了很久，挑出了二十多个让她印象深刻的片段，整理成了这份合集。",
      "其中出现最多的一类，是“带笔记的教材”。不少毕业生会在群里低价转手自己写满批注的专业书，还会附上一句“希望它继续被用起来”。有买家后来在群里晒出自己补充的新笔记，两届学生的字迹叠在同一页上。",
      "另一类则是“送”。有人毕业前把用了四年的台灯和收纳箱直接送给了学弟学妹，条件只有一个：“明年你也送出去。”",
      "阿柚说，整理这份合集的时候她一直有点想笑又有点感动，因为这些看起来普通的交易，让一个陌生的校园变得具体了起来。",
      "本文根据网友整理的公开投稿内容发布，涉及的个人信息与院系信息均已做模糊处理。",
    ],
  },
  {
    id: "c5",
    slug: "community-renovation-neighbors",
    title: "老社区改造后邻里关系变了样，居民投稿讲述变化",
    excerpt:
      "楼道翻新、加装电梯、门口多了个口袋花园。住了二十年的居民投稿，聊了聊改造之后邻里之间那些微妙又真实的变化。",
    categoryId: "society",
    categoryName: "社会民生",
    author: "投稿网友 · 陈阿姨",
    date: "2026-08-30",
    readTime: "6 分钟",
    views: 15620,
    likes: 1108,
    comments: 197,
    tags: ["社区改造", "邻里关系", "城市生活"],
    image:
      "https://readdy.ai/api/search-image?query=Flat%20vector%20illustration%20of%20a%20renovated%20old%20residential%20alley%20with%20plants%20and%20benches%2C%20warm%20terracotta%20and%20sage%20tones%20on%20cream%20background%2C%20minimal%20editorial%20style%2C%20soft%20grain%2C%20no%20text&width=800&height=520&seq=clue-cover-society-05&orientation=landscape",
    imageAlt: "社会民生投稿：老社区改造后口袋花园的插画示意",
    hot: false,
    picks: false,
    quote: "门一修好，大家反而更愿意在楼下多待一会儿。",
    content: [
      "陈阿姨在这个小区住了二十多年。她说改造之前，楼道墙皮脱落、单元门常年关不严，晚上几乎没人愿意在楼下停留。",
      "这次改造最直观的变化，是公共空间变得“可用”了：单元门换了新的门禁，楼道重新粉刷，原来堆杂物的一角被整理成了口袋花园，还添了两条长椅。",
      "变化最微妙的地方是人。以前大家点头之交，现在坐在长椅上的邻居会主动搭话，谁家老人几天没下楼，都会有人顺口问一句。孩子放学后也在花园里写作业、等家长。",
      "当然也有新的小摩擦，比如花园里的花该谁浇水、晚上聊天声音多大算合适、电动车还停不停在楼道口。陈阿姨觉得这些都是“好起来之后的烦恼”，慢慢商量总能解决。",
      "她最后说，社区改造改的不只是墙面和门禁，更是让原本各过各的人，重新有了打交道的机会。本文系网友投稿，内容代表投稿人个人观察。",
    ],
  },
  {
    id: "c6",
    slug: "film-set-leak-rational-discussion",
    title: "剧组路透引热议，网友理性讨论拍摄与追星的边界",
    excerpt:
      "一组拍摄现场照片在社交平台流传，引发了关于“路透文化”的讨论。有网友投稿，希望大家把讨论落回到具体的边界问题上。",
    categoryId: "ent",
    categoryName: "娱乐八卦",
    author: "投稿网友 · 星野",
    date: "2026-08-28",
    readTime: "5 分钟",
    views: 26310,
    likes: 1476,
    comments: 508,
    tags: ["剧组路透", "理性讨论", "追星边界"],
    image:
      "https://readdy.ai/api/search-image?query=Flat%20vector%20illustration%20of%20a%20video%20camera%20and%20clapperboard%20with%20abstract%20spotlights%2C%20warm%20amber%20and%20terracotta%20shapes%20on%20cream%20background%2C%20minimal%20editorial%20style%2C%20no%20text&width=800&height=520&seq=clue-cover-ent-06&orientation=landscape",
    imageAlt: "娱乐八卦投稿：剧组摄影机与场记板的插画示意",
    hot: true,
    picks: false,
    quote: "喜欢一个人和尊重一部作品的拍摄过程，其实并不冲突。",
    content: [
      "上周，一组影视拍摄现场的图片在社交平台被大量转发。有网友认为这是正常的现场花絮，也有人担心过度曝光会影响拍摄进度和其他观众的新鲜感。",
      "投稿人星野把讨论中出现的问题总结成了几条：拍摄现场属于工作场所还是公共空间？路透照片的传播是否会泄露剧情？围观和拍摄该以什么为界？",
      "他注意到，真正有价值的讨论往往集中在具体边界上，比如不干扰拍摄秩序、不传播未公开的关键剧情、不擅自进入封闭区域，而不是简单地给某一方贴标签。",
      "在征集的留言中，也有剧组工作人员匿名分享了一些实际困扰：临时封闭道路时如何与周边居民沟通、夜戏拍摄时怎样尽量减少对居民休息的影响。",
      "我们建议读者在讨论时多引用可核实的信息，少一些情绪化推断。本文内容来自网友投稿与公开讨论整理，不代表平台立场。",
    ],
  },
  {
    id: "c7",
    slug: "smart-home-pitfall-record",
    title: "智能家居踩坑实录：网友投稿自己交过的学费",
    excerpt:
      "买之前觉得什么都智能，用之后才发现处处是前提。一位网友认真记录了自己布置智能家居时踩过的坑，并给出了排序建议。",
    categoryId: "tech",
    categoryName: "科技数码",
    author: "投稿网友 · 苟工",
    date: "2026-08-26",
    readTime: "8 分钟",
    views: 19870,
    likes: 1352,
    comments: 276,
    tags: ["智能家居", "避坑指南", "数码体验"],
    image:
      "https://readdy.ai/api/search-image?query=Flat%20vector%20illustration%20of%20smart%20home%20devices%20like%20a%20hub%2C%20sensor%20and%20smart%20speaker%20connected%20by%20lines%2C%20amber%20and%20sage%20accents%20on%20cream%20background%2C%20minimal%20editorial%20style%2C%20no%20text&width=800&height=520&seq=clue-cover-tech-07&orientation=landscape",
    imageAlt: "科技数码投稿：智能家居设备连接的插画示意",
    hot: false,
    picks: true,
    quote: "先想清楚自动化逻辑，再买设备，能省下一半的钱。",
    content: [
      "苟工是一位爱折腾的普通用户，他把自己两年的智能家居布置经历写成了一份“踩坑实录”，标题就叫《我交过的学费》。",
      "他列出的第一个坑是“先买设备后想逻辑”。刚入门时他看到什么买什么，结果不同品牌设备无法联动，最后不得不额外买网关，成本反而更高。他建议先画出自己想要的日常场景，再反推需要哪些设备。",
      "第二个坑是“忽略网络”。家里设备一多，老路由器就撑不住，时延高、掉线频繁。他后来单独给设备分了一个频段，问题才缓解。",
      "第三个坑是“把便利想得太理想化”。自动化一旦被触发条件卡住，体验反而更差。他的做法是从最基础的一两键操作开始，稳定之后再逐步增加。",
      "文末，他给了一个很实在的排序建议：先灯光，再开关插座，最后才是各种传感器。本文为网友个人体验投稿，不同户型与预算下结论可能不同，仅供参考。",
    ],
  },
  {
    id: "c8",
    slug: "long-distance-timeline",
    title: "异地恋三年后，他们把聊天记录做成了时间轴",
    excerpt:
      "一千多天的消息、语音和照片，被一对网友整理成了一条时间轴。他们说，做的过程比结果更重要。",
    categoryId: "life",
    categoryName: "情感生活",
    author: "投稿网友 · 小满",
    date: "2026-08-22",
    readTime: "5 分钟",
    views: 13470,
    likes: 1004,
    comments: 156,
    tags: ["异地恋", "情感记录", "生活观察"],
    image:
      "https://readdy.ai/api/search-image?query=Flat%20vector%20illustration%20of%20a%20handwritten%20timeline%20with%20message%20bubbles%2C%20small%20photos%20and%20a%20heart%20shape%2C%20warm%20amber%20and%20terracotta%20palette%20on%20cream%20background%2C%20minimal%20style%2C%20no%20text&width=800&height=520&seq=clue-cover-life-08&orientation=landscape",
    imageAlt: "情感生活投稿：聊天记录时间轴的插画示意",
    hot: false,
    picks: false,
    quote: "整理的过程，像是在重新走一遍我们走过的路。",
    content: [
      "小满和她的伴侣异地了三年。今年他们在同一座城市生活之后，决定一起做一件“有仪式感的小事”——把这三年的聊天记录整理成一条时间轴。",
      "她负责筛选，他负责排版。他们从第一天认识的消息开始，按月份标出重要的节点：第一次语音、第一次寄出的包裹、第一次因为小事闹别扭又和好、第一次在地图上把两个城市连成一条线。",
      "整理的过程并不总是轻松的。有些当时觉得过不去的坎，回头看只是两三句对话；有些差点被遗忘的关心，重新读到时又让人鼻子发酸。",
      "小满说，她原本以为这是一份给别人的作品，后来发现其实更像写给自己的一封信。时间轴最后停在同一个日期上，那是他们终于住进同一座城市的那天。",
      "本文系网友授权投稿，人物信息已做适度处理。愿你也能在忙碌里，为在意的人留一点记录的时间。",
    ],
  },
  {
    id: "c9",
    slug: "breakfast-stall-menu-changes",
    title: "早餐摊主坚持十年，用一张菜单记录整条街的变化",
    excerpt:
      "一张贴在摊车上的手写菜单，十年里改了二十多次。摊主说，从改价签就能看出这条街的变化。",
    categoryId: "city",
    categoryName: "城市见闻",
    author: "投稿网友 · 大鹏",
    date: "2026-08-18",
    readTime: "5 分钟",
    views: 16890,
    likes: 1201,
    comments: 189,
    tags: ["城市烟火", "早餐摊", "街巷故事"],
    image:
      "https://readdy.ai/api/search-image?query=Flat%20vector%20illustration%20of%20a%20morning%20breakfast%20food%20cart%20with%20steaming%20buns%20and%20a%20handwritten%20menu%20board%2C%20warm%20amber%20and%20terracotta%20on%20cream%20background%2C%20minimal%20editorial%20style%2C%20no%20text&width=800&height=520&seq=clue-cover-city-09&orientation=landscape",
    imageAlt: "城市见闻投稿：早餐摊与手写菜单的插画示意",
    hot: false,
    picks: false,
    quote: "看菜单上改了多少回，就知道这条街这几年过得怎么样。",
    content: [
      "大鹏在早班路上发现了这家开了十年的早餐摊。让它与众不同的，是摊车上那块被反复涂改的手写菜单。",
      "摊主告诉他，这块板子十年里改过二十多次。“最早这条街都是早晚班的人，后来附近开了写字楼，早上来的白领多了，我就加了咖啡和小份的粥。”",
      "菜单上的字迹叠着不同的笔迹和颜色，像一本被不断更新的日记。价格调整、品类增减、营业时间变化，都留下了痕迹。",
      "大鹏把菜单的变化和这条街的变迁对照着整理了出来。他写道，宏大的城市叙事往往离普通人很远，但一张早餐摊的菜单，反而让“变化”变得可以看见。",
      "本文根据网友实地走访投稿整理，文中摊主姓氏已做模糊处理。拍摄前已征得摊主同意。",
    ],
  },
];

export const faqs: Faq[] = [
  {
    q: "怎样进行匿名投稿？",
    a: "你可以通过站内的投稿入口提交内容，在表单里选择匿名方式，署名为“匿名网友”即可。我们不会在页面展示投稿人的联系方式，投稿身份信息仅用于必要时的内容核实与后续沟通。",
  },
  {
    q: "提交之后一般多久会发布？",
    a: "我们会在收到投稿后的 1 至 3 个工作日内完成初步查看。涉及时间、地点或第三方陈述的内容，可能需要额外的核实时间。若有补充材料，编辑会通过你留下的联系方式联系你。",
  },
  {
    q: "我的个人信息会被公开吗？",
    a: "不会。对于匿名投稿，我们默认隐藏真实姓名与联系方式。对于实名投稿，也会先征得你的同意，再决定哪些信息可以展示。请勿在正文中填写他人隐私信息。",
  },
  {
    q: "哪些内容不会被采纳？",
    a: "无法核实来源、包含具体个人隐私、可能构成对他人名誉损害的指控，以及明显的商业推广、广告引流内容，我们都不会发布。请尽量提供可佐证的材料与时间线。",
  },
  {
    q: "可以对已发布的内容进行更正吗？",
    a: "可以。如果发现内容存在事实误差，或当事人希望补充说明，欢迎通过联系邮箱与我们沟通。核实后我们会在原页面追加更正说明，并保留修改记录。",
  },
  {
    q: "如何举报不实信息？",
    a: "每篇内容下方均有举报入口，也可以在联系页面留下说明。请附上你认为是误的具体句子和相应依据，我们会优先处理涉及事实错误与隐私问题的举报。",
  },
];

export const processSteps = [
  {
    icon: "ri-edit-line",
    title: "填写投稿表单",
    desc: "用几分钟描述清楚事件的时间、地点与经过，并选择匿名或实名。",
  },
  {
    icon: "ri-shield-check-line",
    title: "编辑初步核实",
    desc: "编辑会查看材料完整性，必要时与你沟通补充信息，保护隐私优先。",
  },
  {
    icon: "ri-layout-2-line",
    title: "整理与排版",
    desc: "在不改变事实的前提下梳理叙事顺序，隐去涉及个人的识别信息。",
  },
  {
    icon: "ri-send-plane-line",
    title: "发布与跟进",
    desc: "内容上线后如出现新的进展，我们会在原页面追加更新说明。",
  },
];

export const siteStats = [
  { value: "1,286", label: "累计收到投稿" },
  { value: "980+", label: "已发布线索" },
  { value: "42,000", label: "活跃网友" },
  { value: "1-3天", label: "平均查看时长" },
];

export const testimonials = [
  {
    name: "投稿网友 · 溪午",
    role: "消费维权投稿人",
    text: "原本只是想找个地方把经历记下来，编辑帮我把时间线理清楚之后，我更知道该怎么和商家沟通了。",
  },
  {
    name: "阅读网友 · 木子",
    role: "长期读者",
    text: "这里的爆料有基本的信息整理，不会一上来就下结论，读起来舒服，也愿意多留一会儿。",
  },
  {
    name: "投稿网友 · 老张",
    role: "城市见闻投稿人",
    text: "我拍的是一条老街的日常，本以为没人看，没想到评论区有很多人分享自己记忆里的那条街。",
  },
];

export const siteContact = {
  brand: "17.cc",
  brandCn: "17.cc 网友爆料站",
  email: "contact@17.cc",
  cooperateEmail: "tips@17.cc",
  slogan: "网友爆料 · 投稿吃瓜 · 线索征集",
  intro:
    "17.cc 是一个面向网友的爆料与投稿社区，鼓励大家在核实与尊重隐私的前提下分享真实见闻。我们不做情绪煽动，只把线索整理成可以阅读的内容。",
};